import _ from 'lodash';
export default function Sumprice(productList) {
  if (productList?.length === 0) {
    return 0;
  } else {
    const sumP = _.sumBy(productList, (each) => each?.price * each?.quantity);
    return sumP;
  }
}
